import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, FileText, Megaphone, Users, LogOut, ArrowLeft, Landmark } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const CmsLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const menu = [
    { name: 'Dashboard', path: '/admin/dashboard', icon: <LayoutDashboard className="w-5 h-5" /> },
    { name: 'Manage Blogs', path: '/admin/blogs', icon: <FileText className="w-5 h-5" /> },
  ];

  if (user?.role === 'admin' || user?.role === 'editor') {
    menu.push({ name: 'Manage Temples', path: '/admin/temples', icon: <Landmark className="w-5 h-5" /> });
    menu.push({ name: 'Manage Other Temples', path: '/admin/other-temples', icon: <Landmark className="w-5 h-5" /> });
    menu.push({ name: 'Advertisements', path: '/admin/ads', icon: <Megaphone className="w-5 h-5" /> });
  }

  if (user?.role === 'admin') {
    menu.push({ name: 'Manage Users', path: '/admin/users', icon: <Users className="w-5 h-5" /> });
    menu.push({ name: 'Homepage Settings', path: '/admin/settings', icon: <LayoutDashboard className="w-5 h-5" /> });
  }

  return (
    <div className="flex bg-stone-100 min-h-screen">
      {/* Sidebar */}
      <aside className="w-64 bg-stone-900 text-white min-h-screen flex flex-col fixed inset-y-0 shadow-xl">
        <div className="p-6 border-b border-stone-800">
          <Link to="/" className="flex items-center text-stone-400 hover:text-white transition-colors text-sm mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" /> Back to Website
          </Link>
          <h2 className="text-2xl font-bold tracking-tight">Nathnagri <span className="text-saffron-500">CMS</span></h2>
          <p className="text-stone-400 text-xs mt-1 font-medium">Administration Panel</p>
        </div>

        <nav className="flex-1 py-8 px-4 space-y-2">
          {menu.map(item => (
            <Link 
              key={item.name} 
              to={item.path}
              className={`flex items-center px-4 py-3 rounded-xl transition-colors ${location.pathname === item.path ? 'bg-saffron-600 text-white shadow-lg shadow-saffron-600/20 font-bold' : 'text-stone-300 hover:bg-stone-800 hover:text-white font-medium'}`}
            >
              <span className="mr-3">{item.icon}</span>
              {item.name}
            </Link>
          ))}
        </nav>

        <div className="p-4 border-t border-stone-800">
          <button onClick={() => { logout(); window.location.href = '/'; }} className="w-full flex items-center px-4 py-3 text-red-400 hover:bg-stone-800 rounded-xl transition-colors font-semibold">
            <LogOut className="w-5 h-5 mr-3" /> Logout
          </button>
        </div>
      </aside>

      {/* Main Area */}
      <main className="flex-1 ml-64 p-8 overflow-y-auto h-screen bg-stone-50">
        <div className="bg-white rounded-3xl p-8 shadow-sm border border-stone-200 min-h-full">
          {children}
        </div>
      </main>
    </div>
  );
};

export default CmsLayout;
